const PINNED_SKILL_CARD_ID_PREFIX = 'pinned-skill-card-';

/** The id of the "Loaded <skill>" card drawn for a skill pinned to a message. */
export function getPinnedSkillCardToolCallId({
  messageId,
  versionId,
}: {
  messageId: string;
  versionId: string;
}) {
  return `${PINNED_SKILL_CARD_ID_PREFIX}${messageId}-${versionId}`;
}

export function getIsPinnedSkillCardToolCallId(toolCallId: string) {
  return toolCallId.startsWith(PINNED_SKILL_CARD_ID_PREFIX);
}
